import React from "react";

import FilterTag from "@atoms/FilterTag/FilterTag";

import * as S from "./RegistryAgencyFilterSection.style";
import { StatusFilterValue } from "../../RegistryAgencyFilter.types";

type Props = {
  statusSectionList: StatusFilterValue[];
  filterKey: string;
  statusFilterList: {
    [key: string]: StatusFilterValue[];
  };
  setStatusFilterList: (filterList: {
    [key: string]: StatusFilterValue[];
  }) => void;
};

const RegistryAgencyFilterSection = ({
  statusSectionList,
  filterKey,
  statusFilterList,
  setStatusFilterList,
}: Props) => {
  const handleCheckedStatus = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;
    const updatedStatusFilterList = statusSectionList.map(
      (item: { code: string; isChecked: boolean; name: string }) => {
        if (item.code === value) {
          return { ...item, isChecked: !item.isChecked };
        }
        return item;
      },
    );

    setStatusFilterList({
      ...statusFilterList,
      [filterKey]: updatedStatusFilterList,
    });
  };

  return (
    <S.StatusFilterRow>
      <S.StatusFilterContent>
        <S.StatusFilterFieldset>
          {statusSectionList.map((item) => (
            <FilterTag
              key={`registry-agency-${item.code}`}
              tagType="checkbox"
              onChange={handleCheckedStatus}
              value={item.code}
              checked={item.isChecked}
              filterType="publicationTopicType"
              topicSelected
            >
              {item.name}
            </FilterTag>
          ))}
        </S.StatusFilterFieldset>
      </S.StatusFilterContent>
    </S.StatusFilterRow>
  );
};

export default RegistryAgencyFilterSection;
